import {useQuery, type QueryKey} from '@github-ui/react-query'
import {reactFetch} from '@github-ui/verified-fetch'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'

import type {PreviewStackData} from '../payloads/preview-stack'

export function previewStackQueryKey(pathName: string): QueryKey {
  return [PageData.previewStack, pathName]
}

export function usePreviewStackData() {
  const previewStackURL = usePageDataUrl(PageData.previewStack)

  return useQuery<PreviewStackData | null>({
    queryKey: previewStackQueryKey(previewStackURL),
    queryFn: async () => {
      const result = await reactFetch(previewStackURL)
      if (!result.ok) throw new Error(`HTTP ${result.status}`)
      const json = await result.json()
      return json
    },
    staleTime: Infinity,
  })
}
